<template>
  <v-container grid-list-md fluid>
    <new-appointment
      :patient="patient"
      :visibility.sync="newAppDialog"
      @saved="$router.push('/appointments')"
    />
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="700px">
        <v-card class="px-2">
          <v-card-title>
            <span class="title">{{formTitle}}</span>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-form v-model="valid" ref="form">
              <v-container grid-list-lg fluid>
                <v-layout row wrap>
                  <!-- <v-flex xs12>
                    <v-text-field
                      v-model="editedPatient.serial"
                      :rules="[required]"
                      label="ID Number"
                      required
                    ></v-text-field>
                  </v-flex> -->

                  <v-flex xs12 sm6 md8>
                    <v-text-field
                      v-model="editedPatient.name"
                      :rules="[required]"
                      label="Name"
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedPatient.age" :rules="[required]" label="Age"></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-radio-group :rules="[required]" v-model="editedPatient.gender" row>
                      <v-radio label="Male" value="male"></v-radio>
                      <v-radio label="Female" value="female"></v-radio>
                    </v-radio-group>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field v-model="editedPatient.phone" label="Phone #"></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-textarea v-model="editedPatient.address" label="Address" rows="3"></v-textarea>
                  </v-flex>

                  <v-flex xs12 class="text-xs-right">
                    <v-spacer></v-spacer>
                    <v-btn flat @click="close">Cancel</v-btn>
                    <v-btn
                      class="mx-0"
                      :disabled="!valid"
                      :loading="saving"
                      color="primary"
                      @click="save"
                    >Save</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap align-center>
      <v-flex xs10 sm6>
        <v-text-field
          v-debounce:500ms="getPatients"
          prepend-inner-icon="mdi-magnify"
          label="Search"
          v-model="search"
          hide-details
          single-line
          outline
          class="rounded"
        >
          <v-tooltip top slot="prepend">
            <v-icon
              class="mx-2"
              medium
              slot="activator"
              @click="dialog = true"
              color="secondary"
            >mdi-plus-circle</v-icon>

            <span>New Patient</span>
          </v-tooltip>
        </v-text-field>
      </v-flex>
      <v-flex xs12 pa-0>
        <v-data-table
          :total-items="patients.meta.total"
          :pagination.sync="pagination"
          :headers="headers"
          :items="patients.data"
          disable-initial-sort
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>{{props.item.id}}</td>
              <td class="text-capitalize">{{ props.item.name }}</td>
              <td>{{ props.item.age }}</td>
              <td class="text-capitalize">{{ props.item.gender }}</td>
              <td>{{props.item.phone }}</td>
              <td class="text-capitalize">{{ `${props.item.address}` }}</td>

              <td>
                <v-tooltip top>
                  <v-icon
                    color="primary"
                    slot="activator"
                    class="mx-1"
                    @click="newApp(props.item)"
                  >mdi-clock</v-icon>
                  <span>New Appointment</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-icon
                    slot="activator"
                    class="mx-1"
                    @click="confirmDelete(props.item)"
                  >mdi-delete-outline</v-icon>
                  <span>Delete</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-icon
                    slot="activator"
                    class="mx-1"
                    @click="editPatient(props.item)"
                  >mdi-pencil-outline</v-icon>
                  <span>Edit</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-icon
                    slot="activator"
                    class="mx-1"
                    @click="printSummary(props.item)"
                  >mdi-printer</v-icon>
                  <span>Print Today's Records</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import NewAppointment from "../appointments/new.vue";
export default {
  middleware: "reception",
  components: {
    NewAppointment
  },
  data() {
    return {
      newAppDialog: false,
      patient: {},
      required: v => !!v || "This field is required.",
      valid: true,
      defaultPatient: {
        name: "",
        serial: "",
        age: "",
        gender: "",
        phone: "",
        address: ""
      },
      editedPatient: {
        name: "",
        serial: "",
        age: "",
        gender: "",
        phone: "",
        address: ""
      },
      editedIndex: -1,
      dialog: false,
      search: "",
      pagination: {
        descending: true
      },
      saving: false,
      headers: [
        { text: "#", value: "id" },
        { text: "Patient Name", value: "name" },
        { text: "Age", value: "age" },
        { text: "Gender", value: "gender" },
        { text: "Phone", value: "phone" },
        { text: "Address", value: "address" },
        { text: "", value: "name", sortable: false, width: 200 }
      ],
      patients: {
        data: [],
        meta: {},
        links: {}
      }
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add New Patient" : "Edit Patient Info";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    pagination: {
      handler() {
        this.getPatients();
      }
    }
  },
  methods: {
    printSummary(patient) {
      this.axios.get(`/api/patients/${patient.id}/summary`).then(resp => {
        this.$store.commit("patients/setSummary", {
          serial: patient.serial,
          name: patient.name,
          age: patient.age,
          gender: patient.gender,
          items: resp.data
        });

        this.$router.push("/patients/print/summary");
      });
    },
    getPatients() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination;

      let query = `/api/patients?rows_per_page=${rowsPerPage}&search=${encodeURIComponent(
        this.search
      )}&page=${page}`;

      if (sortBy) query = `${query}&sort_by=${sortBy}`;
      if (descending !== null) query = `${query}&desc=${descending ? 1 : 0}`;

      this.getDataFromApi(query);
    },
    async getDataFromApi(path) {
      const { data } = await this.axios.get(path);
      if (data) this.patients = data;
    },

    close() {
      this.saving = false;
      this.dialog = false;
      this.$refs.form.reset();
      Object.assign(this.editedPatient, this.defaultPatient);
      this.editedIndex = -1;
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        await this.axios.post("api/patients", this.editedPatient);

        this.getPatients();
        this.close();
      }
    },

    editPatient(patient) {
      this.editedIndex = this.patients.data.indexOf(patient);
      Object.assign(this.editedPatient, patient);
      this.dialog = true;
    },

    confirmDelete(patient) {
      const params = {
        title: `Delete "${patient.name}"`,
        message: `Are you sure, you want to delete the patient "${patient.name}"?`,
        // typeText: true,
        mode: "delete",
        onConfirm: () => this.deletePatient(patient)
      };

      this.$modal.show(params);
    },

    async deletePatient(patient) {
      await this.axios.delete(`api/patients/${patient.id}`);
      this.getPatients();
    },

    newApp(patient) {
      this.patient = patient;
      this.newAppDialog = true;
    }
  },

  mounted() {
    if (this.$route.query.new) {
      this.dialog = true;
    }
  }
};
</script>

<style scoped>
</style>